import React, { Fragment, useEffect, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import consultaHistoricoRepository from './consultaHistoricoRepository'
import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@material-ui/core'
import { formatDate, validatePlaca, validateCpf } from '../../utils/Validators'
import { formatCpfCnpj } from '../../utils/Formatter'
import { Field, Form } from 'react-final-form'
import { Filter, Snackbar, TextField, useFilter } from 'elentari'
import { useLocation } from 'react-router-dom'
import { parseCpf, parseCpfOrCnpj, parsePlaca } from '../../utils/Parse'
import UltimaFicha from './UltimaFicha'

import * as yup from 'yup'
import yupValidation from '../../lib/yupValidation'
import MotoristaFotoPadraoAvatar from '../MotoristaFotoPadrao/MotoristaFotoPadraoAvatar'
import { Alert } from '@material-ui/lab'
import liberacaoAutomaticaRepository from '../LiberacaoAutomatica/LiberacaoAutomaticaRepository'
import { useAbility } from '../Usuarios'
import { getAlphanumericDigits } from '../../utils/Utils'
import { Print } from '@material-ui/icons'
import SolicitacaoPrint from '../Solicitacoes/SolicitacaoPrintProtocolo'
import ReactToPrint from 'react-to-print'
import ComplexDialog from '../../components/ComplexDialog'
import moment from 'moment'
import { BRAND } from '../../branding'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    marginTop: 16
  },
  informacao: {
    padding: 32,
    paddingBottom: 0,
    height: '100%'
  },
  texto: {
    paddingTop: 32,
    paddingBottom: 32,
    height: '100%'
  },
  card: {
    height: '100%'
  },
  cardViagens: {
    marginTop: 16,
    height: '100%'
  }
}))

const ConsultaHistoricoCard = props => {
  const classes = useStyles()
  const [items, setItems] = useState(null)
  const [fetching, setFetching] = useState(false)
  const location = useLocation()
  const [mensagem, setMensagem] = useState('')
  const [atualizarDados, setAtualizarDados] = useState(false)
  const [fetchingLiberacao, setFetchingLiberacao] = useState(false)
  const [confirmLiberacaoOpen, setConfirmLiberacaoOpen] = useState(false)
  const [cpfLiberacao, setCpfLiberacao] = useState(null)
  const [validadeUltimaFicha, setValidadeUltimaFicha] = useState(null)
  const [ability] = useAbility()
  const permitidoLiberarAutomaticamente = ability.can(
    'read',
    'permitidoLiberarAutomaticamenteConsulta'
  )

  const validadeUltimaFichaFormatada = validadeUltimaFicha
    ? moment(validadeUltimaFicha).format('DD/MM/YYYY')
    : 'sem ficha liberada anterior'

  const handleCloseConfirmLiberacao = () => {
    if (fetchingLiberacao) {
      return
    }
    setConfirmLiberacaoOpen(false)
    setCpfLiberacao(null)
    setValidadeUltimaFicha(null)
  }

  const onConfirmLiberacaoAutomatica = async () => {
    setFetchingLiberacao(true)
    const params = new URLSearchParams(location.search)
    const placa = params.get('placa')
    const responseLiberarCpfMotorista = await liberacaoAutomaticaRepository.liberarMotorista(
      cpfLiberacao,
      getAlphanumericDigits(placa)
    )

    if (responseLiberarCpfMotorista.ok) {
      setAtualizarDados(!atualizarDados)
      setMensagem('Motorista liberado com sucesso.')
    } else {
      setMensagem(responseLiberarCpfMotorista.data.error.message)
    }
    setFetchingLiberacao(false)
    setConfirmLiberacaoOpen(false)
    setCpfLiberacao(null)
    setValidadeUltimaFicha(null)
  }

  useEffect(() => {
    const fetchData = async params => {
      setFetching(true)
      setItems(null)
      const response = await consultaHistoricoRepository.getHistorico(params)
      if (response.ok) {
        setItems(response.data)
      } else {
        setItems(null)
      }
      setFetching(false)
    }
    const params = new URLSearchParams(location.search)
    fetchData({
      query: {
        cpf: params.get('cpf'),
        placa: params.get('placa'),
        cpfcnpj: params.get('cpfcnpj')
      }
    })
  }, [location.search])

  useEffect(() => {
    const fetchData = async params => {
      const response = await consultaHistoricoRepository.getHistorico(params)
      if (response.ok) {
        setItems(response.data)
      } else {
        setItems(null)
      }
    }
    const params = new URLSearchParams(location.search)
    fetchData({
      query: {
        cpf: params.get('cpf'),
        placa: params.get('placa'),
        cpfcnpj: params.get('cpfcnpj')
      }
    })
  }, [atualizarDados])

  const ContentViagens = ({ info }) => {
    if (!info.success) {
      return null
    }
    const params = new URLSearchParams(location.search)
    return (
      <Grid
        container
        spacing={3}
        justifyContent="center"
        className={classes.card}
        style={{
          marginBottom: 16
        }}
      >
        <Grid item sm={params.get('cpfcnpj') ? 6 : 12} xs={12}>
          <Paper className={classes.informacao}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12}>
                <Typography variant="h6" align="center">
                  Viagens Motorista: {info.empresa}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {info.viagensMotorista?.quantidade ? (
                  <Viagens {...info.viagensMotorista} />
                ) : (
                  <EmptyViagens pessoa="Motorista" />
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        {params.get('cpfcnpj') && (
          <Grid item sm={6} xs={12}>
            <Paper className={classes.informacao}>
              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12}>
                  <Typography variant="h6" align="center">
                    Viagens Proprietário: {info.empresa}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {info.viagensProprietario?.quantidade ? (
                    <Viagens {...info.viagensProprietario} />
                  ) : (
                    <EmptyViagens pessoa="Proprietário" />
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
    )
  }

  const ImpressaoProtocoloFrotista = () => {
    const [fetching, setFetching] = useState(true)
    const [motoristaFrotista, setMotoristaFrotista] = useState(null)
    const printRef = useRef()

    useEffect(() => {
      const fetchData = async params => {
        setFetching(true)

        try {
          const response = await consultaHistoricoRepository.getMotoristaFrotista(
            params
          )

          if (response.ok) {
            const motorista = response.data
            const veiculos = response.data.veiculos
            delete motorista.veiculos

            setMotoristaFrotista({ motorista, veiculos })
          }

          setFetching(false)
        } catch {
          setFetching(false)
        }
      }

      const params = new URLSearchParams(location.search)

      fetchData({
        query: {
          cpf: params.get('cpf')
        }
      })
    }, [])

    return (
      <Grid item xs={12} className={classes.card}>
        <Paper className={classes.informacao}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" align="center">
                Impressão Protocolo de Carregamento de Motorista Frotista
              </Typography>
            </Grid>
            <Tooltip
              title={
                fetching || !motoristaFrotista
                  ? 'Sem conteúdo para impressão'
                  : ''
              }
            >
              <Grid item xs={12}>
                <ReactToPrint
                  trigger={() => (
                    <Button
                      variant="outlined"
                      color="secondary"
                      fullWidth
                      startIcon={
                        fetching ? <CircularProgress size={10} /> : <Print />
                      }
                      disabled={!motoristaFrotista}
                    >
                      Imprimir
                    </Button>
                  )}
                  content={() => printRef.current}
                />
              </Grid>
            </Tooltip>
          </Grid>
        </Paper>

        <div hidden>
          <Grid ref={printRef}>
            <SolicitacaoPrint item={motoristaFrotista ?? {}} isFrotista />
          </Grid>
        </div>
      </Grid>
    )
  }

  const renderContent = info => {
    if (!info.success) {
      return <Bloqueado />
    }

    const mostrarLiberacaoAutomatica =
      permitidoLiberarAutomaticamente &&
      info.empresaSigla === BRAND.name &&
      !info.alerta?.status &&
      info.motorista?.situacao === 'Inativo' &&
      info.motorista?.cpf

    const cadastroExpirado = info.cadastroExpirado === true

    const onClickLiberacaoAutomatica = () => {
      if (cadastroExpirado) {
        setMensagem('Cadastro expirado. Necessária nova análise.')
        return
      }
      setCpfLiberacao(info.motorista?.cpf)
      setValidadeUltimaFicha(info.validadeUltimaFicha ?? null)
      setConfirmLiberacaoOpen(true)
    }

    return (
      <Grid
        container
        spacing={3}
        justifyContent="flex-start"
        alignContent="center"
        alignItems="center"
        className={classes.card}
      >
        {info.alerta?.status && (
          <Grid item xs={12}>
            <Alert variant="filled" severity="warning">
              {info.alerta.message}
            </Alert>
          </Grid>
        )}
        {info.motorista ? (
          <>
            <Grid item xs={12}>
              <Grid container alignItems="center" alignContent="space-around">
                <Grid item xs>
                  <Typography variant="h6">Motorista</Typography>
                </Grid>

                {mostrarLiberacaoAutomatica && (
                  <Grid item xs="auto">
                    <Tooltip
                      title={
                        cadastroExpirado
                          ? 'Cadastro expirado. Necessária nova análise.'
                          : ''
                      }
                    >
                      <span>
                        <Button
                          type="button"
                          color="primary"
                          variant="outlined"
                          disabled={fetchingLiberacao || cadastroExpirado}
                          style={{ marginTop: 14 }}
                          onClick={onClickLiberacaoAutomatica}
                        >
                          {fetchingLiberacao ? (
                            <CircularProgress
                              size={24}
                              style={{ marginRight: 16, marginLeft: 16 }}
                            />
                          ) : (
                            'Liberar'
                          )}
                        </Button>
                      </span>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Motorista {...info.motorista} />
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography variant="body1" align="center">
                Não possui informações!
              </Typography>
            </Grid>
          </>
        )}
        <Snackbar
          message={mensagem}
          autoHideDuration={6000}
          onClose={() => setMensagem('')}
        />
      </Grid>
    )
  }

  const renderMotoristaInfo = (item, index, total) => (
    <Grid item xs={12} sm={12 / total} className={classes.card} key={index}>
      <Paper className={classes.informacao}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h5" align="center">
              Informações {item.empresa}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ minHeight: '100%' }}>
            {renderContent(item)}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )

  return (
    <>
      <ConsultaHistoricoFilter />
      <Grid container spacing={3} className={classes.root}>
        <Fragment>
          {fetching && (
            <Grid item xs={12}>
              <Grid container spacing={3} justifyContent="center">
                <CircularProgress />
              </Grid>
            </Grid>
          )}

          {items && (
            <Fragment>
              {items.find(item => item.success === true) && (
                <Grid item xs={12}>
                  <UltimaFicha {...props} />
                </Grid>
              )}

              {items.some(item => item.isFrotista) ? (
                <ImpressaoProtocoloFrotista />
              ) : null}
              <Grid item xs={12}>
                <Grid container spacing={3} style={{ height: '100%' }}>
                  {items.map((item, index) =>
                    renderMotoristaInfo(item, index, items.length)
                  )}
                </Grid>
              </Grid>
              {items.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={12 / items.length}
                  className={classes.cardViagens}
                  key={index}
                >
                  <ContentViagens info={item} />
                </Grid>
              ))}
            </Fragment>
          )}
        </Fragment>
      </Grid>
      <ComplexDialog
        open={confirmLiberacaoOpen}
        buttonLabel="Não"
        handleClose={handleCloseConfirmLiberacao}
        primaryAction={onConfirmLiberacaoAutomatica}
        title="Deseja confirmar essa operação?"
        message={`Data de validade que será gravada: ${validadeUltimaFichaFormatada}`}
        primaryActionButtonLabel="Confirmar"
        holdWhileLoading
      />
    </>
  )
}

function ConsultaHistoricoFilter() {
  const configuracoesSchema = yup.object().shape(
    {
      cpf: yup.string().when('placa', {
        is: value => !!value,
        then: yup
          .string()
          .test('teste-cpf', 'CPF Obrigatório/Inválido', validateCpf),
        otherwise: yup.string().notRequired()
      }),
      placa: yup.string().when('cpf', {
        is: value => !!value,
        then: yup
          .string()
          .test('teste-plate', 'Placa Obrigatória/Inválida', validatePlaca),
        otherwise: yup.string().notRequired()
      })
    },
    ['cpf', 'placa']
  )

  const validate = yupValidation(configuracoesSchema)
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      validate={validate}
      labels={{
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="cpf"
            label="CPF Motorista"
            parse={parseCpf}
            component={TextField}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="placa"
            parse={parsePlaca}
            label="Placa"
            component={TextField}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="cpfcnpj"
            label="CPF/CNPJ Proprietario"
            parse={parseCpfOrCnpj}
            component={TextField}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

function Motorista({ nome, cpf = '', limiteCarga, situacao = '' }) {
  const cpfFormated = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography variant="body1">Motorista: {nome}</Typography>
        <Typography variant="body1">Situação: {situacao}</Typography>
        <Typography variant="body1">CPF: {cpfFormated}</Typography>
        <Typography variant="body1">Limite Carga: {limiteCarga}</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <MotoristaFotoPadraoAvatar cpf={cpf} />
      </Grid>
    </>
  )
}

function Bloqueado() {
  return (
    <Grid item xs={12}>
      <Typography variant="body1" align="center">
        Entre em contato com a Central de Cadastros!
      </Typography>
    </Grid>
  )
}

function EmptyViagens({ pessoa }) {
  return (
    <Grid item xs={12}>
      <Typography variant="body1" align="center">
        {pessoa} não possui histórico de viagens!
      </Typography>
    </Grid>
  )
}

function Viagens({ quantidade, destaques, quantidadeUltimas, viagens = [] }) {
  return (
    <>
      <Grid item xs={4}>
        <Typography variant="body1">Total de Viagens: {quantidade}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body1">
          Total de Viagens Mercadoria Específicas: {destaques}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="body1">
          Viagens nos últimos 90 dias: {quantidadeUltimas}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">Detalhes Últimas:</Typography>
        <TableContainer>
          <Table aria-label="Tabela de Viagens" size="small">
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Origem</TableCell>
                <TableCell>Destino</TableCell>
                <TableCell>Produto</TableCell>
                {viagens[0]?.composicao && <TableCell>Composição</TableCell>}
                {viagens[0]?.proprietario && (
                  <TableCell>Proprietário</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {viagens.map((viagem, index) => (
                <TableRow key={index}>
                  <TableCell>{formatDate(viagem.data)}</TableCell>
                  <TableCell>{viagem.origem}</TableCell>
                  <TableCell>{viagem.destino}</TableCell>
                  <TableCell>{viagem.produto}</TableCell>
                  {viagem.composicao && (
                    <TableCell>{viagem.composicao}</TableCell>
                  )}
                  {viagem.proprietario && (
                    <TableCell>
                      {typeof viagem.proprietario === 'object'
                        ? viagem.proprietario.NOME ||
                          formatCpfCnpj(viagem.proprietario.CPFCNPJ) ||
                          ''
                        : viagem.proprietario}
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </>
  )
}

export default ConsultaHistoricoCard
